import { supabase } from '@/integrations/supabase/client';
import { LEGAL_PARAMS_TABLE, legalParamValues, readLegalParams, type LegalParam } from '@/lib/legal-params';

export async function fetchLegalParams(): Promise<LegalParam[]> {
  const { data, error } = await supabase.from(LEGAL_PARAMS_TABLE).select('*').order('position');
  if (error) throw error;
  return readLegalParams(data);
}

export async function fetchLegalParamValues(): Promise<Record<string, number>> {
  try {
    return legalParamValues(await fetchLegalParams());
  } catch {
    return {};
  }
}
